import React, { useEffect, useState } from 'react'
import BackButton from '../../../components/button/BackButton'
import { Navbar } from '../../../components/navbar/Navbar'
import axios from 'axios'
import Table from '../../../components/table/Table'
import DateFormatConverter from '../../../components/input/DateFormatConvert'
import SearchInput from '../../../components/input/SearchInput'
import { BACKEND_URL, E_immatriculation } from '../../../constants/constant'
import { Button } from '../../../components/button/button'

function MiseAJourRF() {
  const [Client , setClient ] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
 
   const [ priseEnCharge , setPriseEnCharge] = useState([]);

   
  useEffect(() => {
    // Récupérer les données depuis le backend
    axios.get(`${BACKEND_URL}/prisecharge`)
      .then((response) => setPriseEnCharge(response.data))
      .catch((error) => {console.error(error);alert(`Il y a une erreur :  ${error}`)});
  }, []);
 
  useEffect(() => {
   // Récupérer les données depuis le backend
   axios.get(`${E_immatriculation}/contribuable`)
     .then((response) => setClient(response.data))
     .catch((error) => {console.error(error);alert(`Il y a une erreur :  ${error}`)});
 }, []);

 const handleSearch = (e) => {
   setSearchTerm(e.target.value);
 };   

const filteredData = Client.filter((client) => 
  client.id && client.id.toLowerCase().includes(searchTerm.toLowerCase()) && client.valide === true && client.bloque === false && client.deces === false && client.radie === false && client.cessation === false 
 );
 

// Header table client
const ClientHeaders = ["Ref démandé", "Raison social",  "Référence Fiscal" , "type" , " Date autorisation" , "Régime fiscal" , "Forme juridique" , "Date de création" , "RIB"];
// Data client Table
const ClientData = filteredData.length > 0 ? 
filteredData
  .filter(item => priseEnCharge.some(pec => pec.id_contribuable === item.id)) // Filtrer les éléments qui ne sont pas dans priseEnCharge
  .map((item) => ([ 
    item.id, 
    item.raison_social, 
    item.reference_fiscal, 
    item.type,
    <DateFormatConverter isoDate={item.date_agrement} />,
    item.regime_fiscal,
    item.forme_juridique,
    <DateFormatConverter isoDate={item.date_creation} />,
    item.rib
  ])) : 
[["Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune"]];

const [selectedRow, setSelectedRow] = useState(null);

const handleRowSelect = (index) => {
  setSelectedRow(index === selectedRow ? null : index);
};

const handleDelete = async () => {
  if (selectedRow === null) {
    alert("Veuillez sélectionner une ligne à supprimer");
    return;
  }

  const selectedId = ClientData[selectedRow][0];
  if (selectedId === "Aucune") return;

  try {
    await axios.delete(`${BACKEND_URL}/prisecharge/${selectedId}`);
    
    // Mettre à jour la liste après suppression
    setPriseEnCharge(priseEnCharge.filter(pec => pec.id_contribuable !== selectedId));
    setSelectedRow(null);
    alert("Suppression réussie");
  } catch (error) {
    console.error(error);
    alert(`Erreur lors de la suppression : ${error}`);
  }
};

 
  const Navbarcontent = (
    <div className='flex justify-between '>
      <div className='text-white font-semibold'>
      Mise à jour 
     </div>
     <div>
<BackButton to="/immatriculation"></BackButton>
     </div>
    </div>
 )
  return (
    <div  className='bg-[#212122] h-screen w-screen'>
         <Navbar content={Navbarcontent}></Navbar>
       <div className='p-4'>
    
     <div className='p-4 bg-black mt-2 rounded '>
       <p className='text-white text-xl text-center font-semibold'>RENSEIGNEMENTS GENERAUX</p>
     </div>

     <div>
      <SearchInput onChange={handleSearch}></SearchInput>
     </div>
     <div className='mt-2 flex justify-between'>
      <div className='overflow-y-auto w-[1400px]'>
      {ClientData.length === 0 ? (
  <div className="text-white text-center mt-4">Aucune donnée disponible</div>
) : (
  <Table headers={ClientHeaders} data={ClientData} onClick={handleRowSelect} selectedRowIndex={selectedRow} />
)}

      </div>
     </div>
     <div className='flex justify-between mt-2'>
     <div className='flex justify-end mt-4'>
          <Button 
            onClick={handleDelete}

          >
            Supprimer
          </Button>
          </div>
    </div>
    </div>
    </div>
  )
}


export default MiseAJourRF